import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

/* ICONS */
import CoursesCatalogueFAQIcon from "../../../assets/icons/CoursesCatalogueFAQ.svg";
import CyberRangeFAQIcon from "../../../assets/icons/CyberRangeFAQ.svg";
import AssessmentFAQIcon from "../../../assets/icons/AssessmentFAQ.svg";
import QuizFAQIcon from "../../../assets/icons/QuizFAQ.svg";
import SupportTicketFAQIcon from "../../../assets/icons/SupportTicketFAQ.svg";
import ProfileAccountFAQIcon from "../../../assets/icons/ProfileAccountFAQ.svg";
import GeneralTechnicalFAQIcon from "../../../assets/icons/GeneralTechnicalFAQ.svg";
import DocumentsFAQIcon from "../../../assets/icons/DocumentsFAQ.svg";

/* CATEGORY DATA */
const categories = [
  { id: 1, title: "Knowledge Management", icon: DocumentsFAQIcon, bg: "#0D3744" },
  { id: 2, title: "Assessments", icon: AssessmentFAQIcon, bg: "#A89352" },
  { id: 3, title: "Quizzes", icon: QuizFAQIcon, bg: "#7B3E87" },
  { id: 4, title: "Support & Tickets", icon: SupportTicketFAQIcon, bg: "#2F4B58" },
  { id: 5, title: "Profile & Account", icon: ProfileAccountFAQIcon, bg: "#1E5A2F" },
  { id: 6, title: "General & Technical", icon: GeneralTechnicalFAQIcon, bg: "#7E3F36" },
];

const Faq = () => {

  const [search, setSearch] = useState("");

  return (
    <div className="px-4 py-6">

      {/* SEARCH BAR */}
      <div className="max-w-2xl mx-auto mb-10 relative">
        <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="
            w-full pl-12 pr-4 py-3 rounded-lg
            border border-slate-300 dark:border-slate-600
            bg-white dark:bg-slate-800
            text-slate-900 dark:text-slate-100
            focus:outline-none
          "
        />
      </div>

      {/* CATEGORY CARDS */}
      {!search && (
        <div
          className="
            grid gap-6
            grid-cols-1
            sm:grid-cols-2
            md:grid-cols-3
            xl:grid-cols-3
          "
        >
          {categories.map((item) => (
            <div
              key={item.id}
              className="
                relative cursor-pointer
                rounded-xl
                bg-white dark:bg-slate-800
                border border-slate-200 dark:border-slate-700
                shadow-sm hover:shadow-md
                transition
                overflow-hidden
              "
            >
              {/* TOP HALF BACKGROUND */}
              <div
                className="h-[140px] w-full"
                style={{ backgroundColor: item.bg }}
              />

              {/* CENTER IMAGE */}
              <div className="absolute top-[50px] left-1/2 -translate-x-1/2">
                <div className="">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="h-50 w-50 object-contain"
                  />
                </div>
              </div>

              {/* TITLE */}
              <div className="pt-24 pb-6 text-center">
                <p className="text-base font-medium text-slate-900 dark:text-slate-100">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Faq;